// extracted by mini-css-extract-plugin
module.exports = {"userInfoTable":"StudentsInfoTable_userInfoTable__3RqE3","listHeader":"StudentsInfoTable_listHeader__3xn1d","userInfo":"StudentsInfoTable_userInfo__3ufs6"};